<template>
  <div
    class="flex"
  >
    <el-tooltip
      :disabled="!props.tooltip"
      :content="props.tooltip"
      placement="top"
      :show-after="200"
      :enterable="false"
    >
      <el-button
        link
        :icon="props.icon"
        :loading="props.loading"
        :disabled="props.disabled"
        :type="props.type"
        class="!m-[3px]"
        :class="BUTTON_CLASS_MAP[props.size]"
        @click="onClick"
      />
    </el-tooltip>
  </div>
</template>

<script setup lang="ts">
import type {
  Component,
} from "vue";
import type {
  ButtonProps,
} from "element-plus";

type PropsType = {
  icon: Component;
  loading?: boolean;
  disabled?: boolean;
  tooltip?: string;
  type?: ButtonProps["type"];
  size?: 16 | 20 | 24;
};

const props = withDefaults(defineProps<PropsType>(), {
  loading: false,
  disabled: false,
  tooltip: "",
  type: "default",
  size: 20,
});

// const WRAPPER_CLASS_MAP = {
//   16: "!w-[28px] !h-[28px]",
//   20: "!w-[32px] !h-[32px]",
//   24: "!w-[36px] !h-[36px]",
// };

const BUTTON_CLASS_MAP = {
  16: "!text-base !w-[22px] !h-[22px]",
  20: "!text-xl !w-[26px] !h-[26px]",
  24: "!text-2xl !w-[30px] !h-[30px]",
};

const emits = defineEmits<{
  (e: "click", event: MouseEvent): void;
}>();

function onClick(event: MouseEvent) {
  if (props.disabled) {
    return;
  }

  emits("click", event);
}
</script>
